import React from 'react';
import ReactDOM from 'react-dom';
import HomeBuyingSteps from "./homeBuyingSteps";

const el = document.querySelector('#home-buying-step .step-root-class');

if (el) {
    ReactDOM.render(
        <HomeBuyingSteps />
        ,
        el
    )
}
